<template>
    <div class="mt-3">
      <el-row :gutter="15">
        <el-col :md="8">
          <el-row :gutter="15">
            <el-col :sm="10">
              <el-input type="text" v-model="search" :disabled="loading" placeholder="Buscar por Nombre" />
            </el-col>
            <el-col :sm="4">
              <el-button type="primary" :disabled="loading" :loading="loading" @click="applySearch">Buscar</el-button >
            </el-col>
          </el-row>
        </el-col>
        <el-col :md="16" style="text-align:right;">
          <el-button-group>
            <el-button 
              v-if="!disableActions"
              :disabled="processing || employeeIsProcessing"
              @click="showConfirmationDialog()"
              >
              Rechazar
            </el-button>
            <el-button 
              type="primary" 
              v-if="!disableActions"
              :disabled="processing || employeeIsProcessing"
              :loading="processing" 
              @click="approve()">
              Aprobar
            </el-button>
          </el-button-group>
        </el-col>
      </el-row>
      <el-row :gutter="15" class="mt-2">
        <el-col :md="24" class="r-tags">
          <div class="r-tag">
            <span class="r-color present"></span>
            Presente
          </div>
          <div class="r-tag">
            <span class="r-color missing"></span>
            Ausente
          </div>
          <div class="r-tag">
            <span class="r-color late"></span>
            Tarde
          </div>
          <div class="r-tag">
            <span class="r-color maternity"></span>
            Maternidad
          </div>
          <div class="r-tag">
            <span class="r-color ins"></span>
            Incapacidad INS
          </div>
          <div class="r-tag">
            <span class="r-color ccss"></span>
            Incapacidad CCSS
          </div>
        </el-col>
      </el-row>
        <el-table
              class="mt-2"
              border
              v-loading="loading"
              :data="records"
              :cell-style="setCellBackground"
              >
              <el-table-column
                fixed
                prop="observation"
                width="240"
                label="Observación">
                <template slot-scope="scope">
                  <el-input
                    type="textarea"
                    :rows="2"
                    :disabled="scope.row.processing || disableActions" 
                    @blur="updateObservation(scope.row)"
                    resize="none"
                    placeholder="Escribe aqui alguna observación"
                    v-model="scope.row.observation">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column
                fixed
                width="230"
                prop="employeeName"
                label="Empleado">
              </el-table-column>
              <el-table-column
                v-for="date in headers"
                :key="reportId + '-' + date"
                :label="date"
                width="60"
                align="center"
                :prop="date+'.total_hours'">
              </el-table-column>
              <el-table-column
                v-for="status in checkStatus"
                :key="reportId + '-' + status.prop"
                :label="status.header"
                width="100"
                align="center"
                :prop="status.prop">
              </el-table-column>
              <el-table-column
                align="right"
                prop="total_hours"
                label="Total Horas">
              </el-table-column>
        </el-table>

        <el-pagination
          layout="prev, pager, next"
          v-show="!loading && total > perPage"
          @current-change="handleCurrentChange"
          :page-size="perPage"
          :total="total">
        </el-pagination>
        <el-dialog
        title="Confirmación"
        width="30%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="showConfirmation">
        <el-form ref="confirmationForm" :model="confirmationForm" :rules="confirmationFormRules" label-position="top">
          <el-form-item label="Observación" prop="observation">
            <el-input
                type="textarea"
                :rows="3"
                :disabled="processing" 
                placeholder="Escribe aquí la razón de porque se rechaza este reporte"
                v-model="confirmationForm.observation">
              </el-input>
          </el-form-item>
        </el-form>
        <div role="alert" v-if="error.message" class="el-alert el-alert--error">
          <div class="el-alert__content">
            <span class="el-alert__title is-bold">{{ error.message }}</span>
            <p class="el-alert__description">
              <ul>
                <li v-for="item in error.errors">{{ item[0] }}</li>
              </ul>
            </p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button 
            @click="showConfirmation = false" 
            :disabled="processing">Cancelar</el-button>
          <el-button type="primary"
                    :disabled="processing || !confirmationForm.observation"
                    :loading="processing"
                    @click="denie()">
            <span v-if="processing">Procesando...</span>
            <span v-else>Rechazar</span>
          </el-button>
        </span>
      </el-dialog>
    </div>
</template>
<script>
import moment from 'moment'
import { baseApi } from '../../../configs/urls'
import { params, parseError } from '../../../packages/Helpers'

export default {
  name: 'checkin-revision-table',
  props: ['reportId', 'headers', 'disabled'],
  data () {
    return {
      checkStatusColors: [
        '#A1E287', // Presente
        '#EC9797', // Ausente
        '#EADA85', // Tarde
        '#B99EF1', // Maternidad
        '#FFFFFF', // INS
        '#81C7EA' // CCSS
      ],
      checkStatus: [
        { header: 'T. Presente', prop: 'present' },
        { header: 'T. Ausente', prop: 'missing' },
        { header: 'T. Tarde', prop: 'late' },
        { header: 'T. Maternidad', prop: 'maternity' },
        { header: 'T. INS', prop: 'ins' },
        { header: 'T. CCSS', prop: 'ccss' }
      ],
      perPage: 15,
      search: '',
      loading: false,
      processing: false,
      pagination: {},
      current_page: 1,
      disableActions: this.disabled,
      showConfirmation: false,
      confirmationForm: {
        observation: ''
      },
      confirmationFormRules: {
        observation: [{required: true, message: 'La observación es requerida', trigger: 'blur'}]
      },
      error: {},
      total: 0,
      records: []
    }
  },
  watch: {
    disabled (newVal) {
      this.disableActions = newVal
    }
  },
  computed: {
    employeeIsProcessing () {
      return this.records.some(({processing}) => processing === true)
    }
  },
  methods: {
    setCellBackground ({row, column, columnIndex}) {
      let cssClass = ''
      const headerName = (column.property.includes('.')) ? column.property.split('.')[0] : column.property
      if (columnIndex > 1 && row[headerName] && row[headerName].checkin_status_id) {
        cssClass = this.checkStatusColors[row[headerName].checkin_status_id - 1]
      }
      return {
        backgroundColor: cssClass
      }
    },
    handleCurrentChange (event) {
      this.current_page = event
      this.refreshRecords()
    },

    applySearch (event) {
      event.preventDefault()
      event.stopPropagation()

      this.current_page = 1
      this.refreshRecords()
    },
    refreshRecords () {
      if (this.loading) {
        return
      }

      const query = {
        page: this.current_page,
        term: this.search,
        paginate: true
      }

      this.loading = true
      this.$http.get(baseApi + '/checkins-report/' + this.reportId + '/checkins' + params(query))
        .then(
          (res) => {
            this.loading = false

            const data = res.body.data.map((employee) => {
              let totalHours = 0
              this.checkStatus.forEach((status) => {
                employee[status.prop] = 0
              })

              this.headers.forEach((date, index) => {
                const checkin = employee.checkins.find((checkin) => {
                  return moment(checkin.date).format('MM-DD') === date
                })

                employee[date] = {}

                if (checkin) {
                  checkin.worked_hours = Number(checkin.worked_hours)
                  checkin.extra_hours = Number(checkin.extra_hours)
                  checkin.double_hours = Number(checkin.double_hours)
                  checkin.total_hours = checkin.worked_hours + checkin.extra_hours + checkin.double_hours
                  totalHours += checkin.total_hours
                  employee[date] = checkin

                  const status = this.checkStatus[checkin.checkin_status_id - 1]
                  if (status) {
                    employee[status.prop]++
                  }
                }
              })
              delete employee.checkins
              employee.total_hours = totalHours
              employee.observation = ''
              employee.current_observation = ''
              employee.processing = false

              if (employee.checkins_report_observations && employee.checkins_report_observations.length > 0) {
                employee.observation = employee['checkins_report_observations'][0].observation
                employee.current_observation = employee.observation
              }
              return employee
            })

            this.records = data
            this.total = res.body.total
            this.$emit('update-table', this.total)
          },
          (res) => {
            this.loading = false
          }
        )
    },

    showConfirmationDialog () {
      this.showConfirmation = true
    },
    denie () {
      if (this.processing) {
        return
      }

      this.$refs['confirmationForm'].validate((valid) => {
        if (valid) {
          this.processing = true
          this.$http.post(
              baseApi + '/checkins-report/' + this.reportId + '/denie',
              this.confirmationForm
            )
            .then(
              (res) => {
                this.processing = false
                this.$emit('report-updated', res.body)
                this.showConfirmation = false
                this.$message.success('El reporte de asistencia se rechazo.')
              },
              (res) => {
                this.processing = false
                this.$message.error(parseError(res)[0])
              }
            )
        }
      })
    },
    approve () {
      if (this.processing) {
        return
      }

      this.processing = true
      this.$http.post(baseApi + '/checkins-report/' + this.reportId + '/approve')
        .then(
          (res) => {
            this.processing = false
            this.$emit('report-updated', res.body)
            this.$message.success('El reporte de asistencia se aprobo correctamente.')
          },
          (res) => {
            this.processing = false
            this.$message.error(parseError(res)[0])
          }
        )
    },
    updateObservation (employee) {
      if (employee.processing || (!employee.observation && !employee.current_observation)) {
        return
      }

      employee.processing = true
      let data = null
      if (employee.observation !== employee.current_observation) {
        data = {
          observation: employee.observation
        }
      }
      this.$http
        .post(baseApi + '/checkins-report/' + this.reportId + '/observation/' + employee.id, data)
        .then(
          () => {
            employee.processing = false
            employee.current_observation = employee.observation
            this.$message.success('Se guardo correctamente la observación de '.employee.employeeName)
          },
          (res) => {
            employee.processing = false
            employee.observation = employee.current_observation
            if (
              res.body &&
              res.body.observation &&
              res.body.observation.length > 0
            ) {
              this.$message.error(res.body.observation[0])
            } else {
              this.$message.error(parseError(res)[0])
            }
          }
        )
    }
  },
  mounted () {
    this.refreshRecords()
  }
}
</script>

<style lang="scss" scoped>
  .r-tag {
    margin-right: 5px;
    display: inline-block;
    font-size: 14px;

    .r-color {
      width: 15px;
      height: 15px;
      display:inline-block;
      border-radius: 3px;
      border: 1px solid black;

      &.present {
        background-color: #A1E287;
      }
      &.missing {
        background-color: #EC9797;
      }
      &.late {
        background-color: #EADA85;
      }
      &.maternity {
        background-color: #B99EF1;
      }
      &.ins {
        background-color: #fff;
      }
      &.ccss {
        background-color: #81C7EA;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/checkins/approval/CheckinRevisionTable.vue